import { createFileRoute } from '@tanstack/react-router';
import BaseView from 'containers/Base/BaseView';
import { baseModuleConfigs } from 'containers/Base/baseModuleConfigs';

export const Route = createFileRoute('/_authenticated/laborRecs')({
  component: () => <BaseView configuration={baseModuleConfigs['Labor Records']} />,
});
